/**
 * this service will encapsulate the endpoint calls to the calculator service
 * @returns {CalculatorService}
 * @constructor
 */
let CalculatorService = function CalculatorService($http) {

  let sv = this;

  const headers = {
    // 'Content-Type': 'application/json',
    // 'Csrf-Token':'',
    // 'Cookie': ''
  };

  /**
   *  uses the calculator field inputs and returns the resulting amounts to display
   * @param obj
   */
  sv.getCalculations = (obj) => {
    let req = {
      method: 'POST',
      url: '/api/calculator',
      headers: headers,
      data: obj
    };
    return $http(req).then(res => {
      return res.data.data;
    });
  };

  /**
   * calculates and emails the calculator field results to the given user
   * @param obj
   */
  sv.emailCalculations = (obj) => {
    let req = {
      method: 'POST',
      url: '/api/calculator/email',
      headers: headers,
      data: obj
    };
    return $http(req).then(res => {
      return res.data;
    });
  };

  return sv;

};

CalculatorService.$inject = ['$http'];

export default CalculatorService;



// WEBPACK FOOTER //
// ./client/app/services/CalculatorService.js